import { render, staticRenderFns } from "./GuideItem.vue?vue&type=template&id=38cbe36e&scoped=true"
import script from "./GuideItem.vue?vue&type=script&lang=js"
export * from "./GuideItem.vue?vue&type=script&lang=js"
import style0 from "./GuideItem.vue?vue&type=style&index=0&id=38cbe36e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cbe36e",
  null
  
)

export default component.exports